require './base'
require '../../modules/merchant/frontend/subtitle_tooltip'
require '../../modules/tips/frontend/tips_controller'
require '../../modules/offers/frontend/offers_timer'
require '../../modules/goods_v2/frontend/read_more'
require '../../modules/wishlist_button/frontend/wishlist'
require '../../node_modules/grpn-tip-widget/frontend/coffeescripts/tip_widget'

require './booking'
require '../../modules/deal/frontend/glive_booking_wrapper'
require '../../modules/merchant/frontend/lazy_load'
